export default __webpack_public_path__ + "static/media/bg-path.3b8eac60.png";